import {createContext} from 'react'
export const CampaignItemContext = createContext({})
export const CohortContext = createContext({})